module.exports = __webpack_public_path__ + "img/confirmed-clock.da31880b.png";